import  "./Greek2022.css"

const Greek2022 = ()=>{
     
    return (
    <>        
     
    </>
    )
}

export default Greek2022;